import { photoSizeApi } from "src/services/api";
import { GetPhotoSizeDto } from "src/services/generated-api";

export async function fetchPhotoSizes(): Promise<GetPhotoSizeDto[]> {
  // First arg is `includeHidden` — left undefined so the public list stays filtered (hidden sizes excluded).
  const response = await photoSizeApi.getManyBasePhotoSizeControllerPhotoSize(undefined, undefined, undefined, undefined, undefined, undefined, undefined, 100);
  return (response.data as { data: GetPhotoSizeDto[] }).data;
}

export async function fetchPhotoSizeById(
  id: string,
): Promise<GetPhotoSizeDto | null> {
  try {
    const response =
      await photoSizeApi.getOneBasePhotoSizeControllerPhotoSize(
        id,
        undefined,
        undefined,
        undefined,
      );
    return response.data as unknown as GetPhotoSizeDto;
  } catch {
    return null;
  }
}
